/** Lightweight client-side CSV export — no external dependency needed. */
export function toCSV(rows: any[], columns?: { key: string; label: string }[]): string {
  if (!rows || !rows.length) return '';
  const cols = columns || Object.keys(rows[0]).map(k => ({ key: k, label: k }));
  const escape = (v: any) => {
    if (v === null || v === undefined) return '';
    const s = typeof v === 'object' ? JSON.stringify(v) : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = cols.map(c => escape(c.label)).join(',');
  const body = rows.map(r => cols.map(c => escape(r[c.key])).join(',')).join('\n');
  return `${header}\n${body}`;
}

/** Triggers a browser download of the given text content as a file. */
export function downloadFile(content: string, filename: string, mimeType = 'text/csv;charset=utf-8;') {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function downloadCSV(rows: any[], filename: string, columns?: { key: string; label: string }[]) {
  const csv = toCSV(rows, columns);
  downloadFile(csv, filename.endsWith('.csv') ? filename : `${filename}.csv`, 'text/csv;charset=utf-8;');
}
